module.exports = [{"componentChunkName":"component---src-pages-articles-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"articles.json","path":"/articles/"},{"componentChunkName":"component---src-pages-contact-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"contact.json","path":"/contact/"},{"componentChunkName":"component---src-pages-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"index.json","path":"/"}]


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = 456
// module chunks = 231608221292675